var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cloumn-item"},[_c('span',{staticClass:"item-border top-left"}),_c('span',{staticClass:"item-border bottom-left"}),_c('span',{staticClass:"item-border top-right"}),_c('span',{staticClass:"item-border bottom-right"}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }